   (() => {
 
    const HOLDER_SELECTOR = '[id="CartDrawerRecommendations"]';  
    const LIMIT           = 12;
    const RECS_URL        = '{{ routes.product_recommendations_url }}';
  
  
    const buildRecUrl = pid =>
      `${RECS_URL}?section_id=shopify-section-header` +
      `&product_id=${pid}&limit=${LIMIT}&intent=related&section_id=product-recommendations`;
  
    const formatPrice = money => {
      const normalized = Number(money) > 1000 ? money / 100 : Number(money);
      return normalized.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
    };
  
    const productCard = p => {
      const url = `/products/${p.handle}`;
      const img = p.images?.[0]?.src
        ? p.images[0].src.replace(/(\.[a-z]+)(\?.*)?$/, '_400x$1')
        : '//cdn.shopify.com/s/assets/no-image-400x.gif';
      return `
        <div class="grid__item grid-product small--one-half medium-up--one-quarter">
          <a href="${url}" class="grid-product__link">
            <div class="image-wrap"><img src="${img}" alt="${p.title}"></div>
            <div class="grid-product__meta">
              <div class="grid-product__title">${p.title}</div>
              <div class="grid-product__price">${formatPrice(p.variants[0].price)}</div>
            </div>
          </a>
        </div>`;
    };
  
    const fetchFallback = async handle => {
      try {
        const res  = await fetch(`/collections/${handle}/products.json?limit=${LIMIT}`);
        const json = await res.json();
        return (json.products || []).map(productCard).join('');
      } catch (e) {
        console.error('fallback fetch error', e);
        return '';
      }
    };
  
    const insertBlock = (el, title, bodyHtml) => {
      el.innerHTML =
        `<div class="header-part">${title}</div>
         <div class="product-part" data-event="open">${bodyHtml}</div>`;
      if (typeof theme?.initQuickShop === 'function') theme.initQuickShop();
    };
  
    const renderHolder = async (holder, productIdFromCart) => {
      holder.innerHTML = '';
  
      const fallbackColl = holder.dataset.fallbackCollection || 'ymi-best-sellers';
      let recUrl = holder.dataset.url || null;
  
      if (!recUrl && productIdFromCart) recUrl = buildRecUrl(productIdFromCart);
  
      if (!recUrl) {
        const fb = await fetchFallback(fallbackColl);
        if (fb) insertBlock(holder, 'Best Sellers', fb);
        return;
      }
  
      try {
        const html = await fetch(recUrl).then(r => r.text());
        const tmp  = document.createElement('div'); tmp.innerHTML = html;
        const recs = tmp.querySelector('.product-recommendations');
  
        if (recs && recs.innerHTML.trim()) {
          insertBlock(holder, 'Frequently Bought Together', recs.innerHTML);
        } else {
          const fb = await fetchFallback(fallbackColl);
          if (fb) insertBlock(holder, 'Best Sellers', fb);
        }
      } catch (e) {
        console.error('recommendations fetch error', e);
        const fb = await fetchFallback(fallbackColl);
        if (fb) insertBlock(holder, 'Best Sellers', fb);
      }
    };
  
    const renderAll = async () => {
      const holders = Array.from(document.querySelectorAll(HOLDER_SELECTOR));
      if (!holders.length) return;
  
      let firstId = null;
      try {
        const cart = await fetch('/cart.js').then(r => r.json());
        firstId = cart.items?.[0]?.product_id || null;
      } catch (e) { console.error('cart fetch error', e); }
  
      holders.forEach(h => renderHolder(h, firstId));
    };
  
  
    new MutationObserver(() => {
      if (document.body.classList.contains('drawer--is-open')) renderAll();
    }).observe(document.body, { attributes: true, attributeFilter: ['class'] });
  
    const nativeFetch = window.fetch;
    window.fetch = async (...args) => {
      const res = await nativeFetch.apply(this, args);
      try {
        const url = typeof args[0] === 'string' ? args[0] : args[0].url;
        if (/\/cart\/(add|change|update)(\.js)?/i.test(url)) renderAll();
      } catch {/* ignore */}
      return res;
    };
  
    document.addEventListener('DOMContentLoaded', renderAll);
  })();
  